import { useTheme } from "next-themes";
import {
  Toaster as Sonner,
  toast as sonnerToast,
  type ToasterProps
} from "sonner";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      style={
        {
          "--normal-bg": "var(--popover)",
          "--normal-text": "var(--popover-foreground)",
          "--normal-border": "var(--border)"
        } as React.CSSProperties
      }
      richColors
      closeButton
      expand={false}
      visibleToasts={5}
      position="top-right"
      {...props}
    />
  );
};

const toast = (
  options:
    | {
        title?: string;
        description?: string;
        variant?: "default" | "destructive" | "success";
        duration?: number;
      }
    | string
) => {
  if (typeof options === "string") {
    return sonnerToast(options);
  }

  const { title, description, variant = "default", duration } = options;

  if (variant === "destructive") {
    return sonnerToast.error(title, {
      description,
      duration
    });
  } else if (variant === "success") {
    return sonnerToast.success(title, {
      description,
      duration
    });
  } else {
    return sonnerToast(title, {
      description,
      duration
    });
  }
};

toast.success = (message: string, data?: any) =>
  sonnerToast.success(message, data);
toast.error = (message: string, data?: any) => sonnerToast.error(message, data);
toast.info = (message: string, data?: any) => sonnerToast.info(message, data);
toast.warning = (message: string, data?: any) =>
  sonnerToast.warning(message, data);
toast.loading = (message: string, data?: any) =>
  sonnerToast.loading(message, data);
toast.promise = sonnerToast.promise;
toast.dismiss = sonnerToast.dismiss;
toast.custom = sonnerToast.custom;

export { Toaster, toast };
